import { useEffect, useRef } from "react";

const NOTIFICATIONS_REFRESH_EVENT = "notifications-refresh";
const PERSISTENCE_RETRY_DELAY_MS = 1500;

function refreshExistingNotifications() {
  window.dispatchEvent(new Event(NOTIFICATIONS_REFRESH_EVENT));
}

export default function useMonitoringNotificationRefresh(activeAlertCount) {
  const previousCount = useRef(null);
  const retryTimers = useRef(new Set());

  useEffect(() => () => {
    retryTimers.current.forEach((timer) => window.clearTimeout(timer));
    retryTimers.current.clear();
  }, []);

  useEffect(() => {
    if (!Number.isSafeInteger(activeAlertCount) || activeAlertCount < 0) return;

    const previous = previousCount.current;
    previousCount.current = activeAlertCount;
    if (previous === null || activeAlertCount <= previous) return;

    refreshExistingNotifications();
    const retryTimer = window.setTimeout(() => {
      retryTimers.current.delete(retryTimer);
      refreshExistingNotifications();
    }, PERSISTENCE_RETRY_DELAY_MS);
    retryTimers.current.add(retryTimer);
  }, [activeAlertCount]);
}

export { NOTIFICATIONS_REFRESH_EVENT, PERSISTENCE_RETRY_DELAY_MS };
